<div class="background-img">
  <div class="background">
    <mat-card appearance="outlined" class="card-primary">
      @if (!paymentCancel) {
        <mat-card-content>
          <h1 class="title">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
              <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg
            >{{ 'vouchers.mollie-redirect.title' | translate | capitalize }}
          </h1>
          <div>
            <p>{{ 'vouchers.mollie-redirect.description' | translate | capitalize }}</p>
          </div>
          @if (voucherResponseCode === 'VOU_001') {
            <div>
              <!-- Voucher active -->
              <p>{{ 'vouchers.mollie-redirect.active.description' | translate | capitalize }}</p>
              <button class="action-button" mat-raised-button color="primary" (click)="openDEPD()">
                {{ 'vouchers.mollie-redirect.active.action' | translate | capitalize }}
              </button>
            </div>
          }
          @if (voucherResponseCode === 'VOU_002') {
            <div>
              <!-- Voucher active per certain date -->
              <p>
                {{
                  'vouchers.mollie-redirect.inactive.description'
                    | translate: { DATE: voucherActiveDate | date: 'dd-MM-yyyy' }
                    | capitalize
                }}
              </p>
              <button class="action-button" mat-raised-button color="primary" (click)="openDEPD()">
                {{ 'vouchers.mollie-redirect.inactive.action' | translate | capitalize }}
              </button>
            </div>
          }
        </mat-card-content>
      }
      @if (paymentCancel) {
        <mat-card-content>
          <h1>{{ 'vouchers.mollie-redirect.error.title' | translate | capitalize }}</h1>
          <p>{{ 'vouchers.mollie-redirect.error.description' | translate | capitalize }}</p>
          <button class="action-button" mat-raised-button color="primary" (click)="openDEPD()">
            {{ 'vouchers.mollie-redirect.error.action' | translate | capitalize }}
          </button>
        </mat-card-content>
      }
    </mat-card>
  </div>
</div>
